if (!window.multiVideoControlsInitialized) {
  window.multiVideoControlsInitialized = true;

  const activateCard = (iframe) => {
    const currentCard = iframe.closest('.multi-video__card');
    if (!currentCard) return;

    document.querySelectorAll('.multi-video__card').forEach((card) => {
      if (card === currentCard) return;

      const youtube = card.querySelector('.multi-video__youtube');
      const youtubeId = youtube && youtube.dataset.youtubeId;
      const shopifyVideo = card.querySelector('.multi-video__shopify-video');

      if (youtube && youtubeId && card.classList.contains('multi-video__card--playing')) {
        youtube.src = `https://www.youtube.com/embed/${youtubeId}?enablejsapi=1&rel=0`;
      }

      if (shopifyVideo && !shopifyVideo.paused) shopifyVideo.pause();
      card.classList.remove('multi-video__card--playing');
    });

    currentCard.classList.add('multi-video__card--playing');
  };

  const startListening = (iframe) => {
    if (!iframe.contentWindow) return;

    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'listening',
      id: iframe.id,
      channel: 'multi-video'
    }), '*');
  };

  const registerIframes = () => {
    document.querySelectorAll('.multi-video__youtube').forEach((iframe, index) => {
      if (iframe.dataset.playerListenerRegistered === 'true') return;

      if (!iframe.id) iframe.id = `multi-video-player-${index + 1}`;
      iframe.dataset.playerListenerRegistered = 'true';
      iframe.addEventListener('load', () => startListening(iframe));
      startListening(iframe);
      window.setTimeout(() => startListening(iframe), 250);
      window.setTimeout(() => startListening(iframe), 1000);
    });
  };

  const registerShopifyVideos = () => {
    document.querySelectorAll('.multi-video__shopify-video').forEach((video) => {
      if (video.dataset.playerListenerRegistered === 'true') return;

      video.dataset.playerListenerRegistered = 'true';
      video.addEventListener('play', () => activateCard(video));
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        const card = video.closest('.multi-video__card');
        if (card) card.classList.remove('multi-video__card--playing');
      });
    });
  };

  document.addEventListener('click', (event) => {
    const playButton = event.target.closest('[data-shopify-video-play]');
    if (!playButton) return;

    event.preventDefault();
    const card = playButton.closest('.multi-video__card');
    const video = card && card.querySelector('.multi-video__shopify-video');
    if (!video) return;

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  });

  window.addEventListener('message', (event) => {
    if (!event.origin.includes('youtube.com')) return;

    let message = event.data;
    if (typeof message === 'string') {
      try {
        message = JSON.parse(message);
      } catch (error) {
        return;
      }
    }

    const iframe = Array.from(document.querySelectorAll('.multi-video__youtube'))
      .find((element) => element.contentWindow === event.source);
    if (!iframe) return;

    const playerState = message && message.event === 'onStateChange'
      ? message.info
      : message && message.info && message.info.playerState;

    if (playerState === 1) activateCard(iframe);
  });

  document.addEventListener('focus', (event) => {
    if (event.target.matches('.multi-video__youtube')) activateCard(event.target);
  }, true);

  window.addEventListener('blur', () => {
    window.setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement.matches('.multi-video__youtube')) {
        activateCard(activeElement);
      }
    }, 0);
  });

  registerIframes();
  registerShopifyVideos();

  document.addEventListener('shopify:section:load', () => {
    registerIframes();
    registerShopifyVideos();
  });
}
